// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.
import React from "react";
import { IElement } from "./types";
import {
  DiagnosticsIcon,
  HealIcon,
  LogsIcon,
  SearchIcon,
  TraceIcon,
  WatchIcon,
} from "../../../icons";

export const configurationElements: IElement[] = [
  {
    icon: <LogsIcon />,
    configuration_id: "logs",
    configuration_label: "Logs",
  },
  {
    icon: <SearchIcon />,
    configuration_id: "audit-logs",
    configuration_label: "Audit Logs",
  },
  {
    icon: <WatchIcon />,
    configuration_id: "watch",
    configuration_label: "Watch",
  },
  {
    icon: <TraceIcon />,
    configuration_id: "trace",
    configuration_label: "trace",
  },
  {
    icon: <HealIcon />,
    configuration_id: "heal",
    configuration_label: "heal",
  },
  {
    icon: <DiagnosticsIcon />,
    configuration_id: "diagnostics",
    configuration_label: "Diagnostics",
  },
];
